export default defineNuxtRouteMiddleware((to) => {
  const { $i18n } = useNuxtApp()
  if ($i18n.strategy !== "no_prefix") return

  // Handle legacy language prefix redirects
  const langs = Object.values(LanguageEnum) as string[]
  if (langs.some((lang) => to.path.startsWith(`/${lang}`))) {
    const pathWithoutLang = to.path.replace(new RegExp(`^/(${langs.join("|")})`), "") || "/"
    const query = to.query

    // Permanent redirect for SEO
    return navigateTo({ path: pathWithoutLang, query }, { redirectCode: 301 })
  }
})
